export const IS_LOADING='IS_LOADING'
export const IS_LOADED='IS_LOADED'
export const SET_CURRENT_USER ="SET_CURRENT_USER"
